import React from 'react';

export const AviporkLogo = ({ className = '', compact = false }) => {
  if (compact) {
    return (
      <div className={`flex items-center justify-center ${className}`} data-testid="brand-logo">
        <img
          src="/avipork-logo.png"
          alt="AVIPORK"
          className="h-12 w-12 object-contain"
        />
      </div>
    );
  }

  // Full logo: imagen única que ya contiene "AVIPORK" + tagline.
  return (
    <div className={`flex items-center justify-center w-full ${className}`} data-testid="brand-logo">
      <img
        src="/avipork-logo.png"
        alt="AVIPORK · Crianza de Primera Calidad"
        className="h-24 w-auto max-w-full object-contain"
      />
    </div>
  );
};
